import { Hotel } from 'app/shared/model/hotel';
import { UtilService } from 'app/shared/util.service';

export type Qualification = 'excellent' | 'good' | 'regular' | 'bad' | 'very_bad' | 'no_data';

export interface NpsVariationMetric {
  actual: number;
  previous: number;
  variation: number;
}

export interface NpsDetails {
  actual: {
    promoters: number;
    passives: number;
    detractors: number;
    promoter_answered_contacted_guest: number;
    passive_answered_contacted_guest: number;
    detractor_answered_contacted_guest: number;
  };
  previous: {
    promoters: number;
    passives: number;
    detractors: number;
    promoter_answered_contacted_guest: number;
    passive_answered_contacted_guest: number;
    detractor_answered_contacted_guest: number;
  };
  variation: number | null;
}

export interface NpsAverage {
  nps: NpsVariationMetric;
  promoter_answered_contacted_guest_rate: NpsVariationMetric;
  passive_answered_contacted_guest_rate: NpsVariationMetric;
  detractor_answered_contacted_guest_rate: NpsVariationMetric;
  answered_contacted_guest_rate: NpsVariationMetric;
  details: NpsDetails;
}

export interface NpsResponse {
  average: NpsAverage;
  values: unknown[];
}

export function canLoadData(utilService: UtilService, chainFilter: Hotel[], surveysReady: boolean): boolean {
  if (!chainFilter.length || !surveysReady) {
    return false;
  }

  const survey = utilService.getCurrentSurvey(chainFilter.map((x) => parseInt(x.id)));
  const surveyIds = survey?.ids || [];

  return surveyIds.length > 0;
}

export function getRequestParams(
  utilService: UtilService,
  chainFilter: Hotel[],
  currentDates: { startDate?: string; endDate?: string },
): {
  dates: { startDate: string; endDate: string };
  surveyIds: string[];
  customerIds: string;
  version: number;
} {
  const startDate = currentDates?.startDate || '';
  const endDate = currentDates?.endDate || '';
  const dates = { startDate, endDate };

  const survey = utilService.getCurrentSurvey(chainFilter.map((x) => parseInt(x.id)));
  const surveyIds = survey.ids;
  const customerIds = chainFilter.map((c) => c.id).join(',');
  const version = survey.survey[0]?.version || 1;

  return { dates, surveyIds, customerIds, version };
}

export function getValidDataRateQualification(value: number | null | undefined): Qualification {
  if (value == null) return 'no_data';
  if (value > 70) return 'excellent';
  if (value >= 50) return 'good';
  if (value >= 40) return 'regular';
  if (value >= 30) return 'bad';
  return 'very_bad';
}

export function getAnswersRateQualification(value: number | null | undefined): Qualification {
  if (value == null) return 'no_data';
  if (value > 30) return 'excellent';
  if (value >= 20) return 'good';
  if (value >= 10) return 'regular';
  if (value >= 5) return 'bad';
  return 'very_bad';
}

export function getAverageRatingQualification(value: number | null | undefined): Qualification {
  if (value == null) return 'no_data';
  if (value > 4.5) return 'excellent';
  if (value >= 4.0) return 'good';
  if (value >= 3.5) return 'regular';
  if (value >= 3.0) return 'bad';
  return 'very_bad';
}

export function getDetractorsRateQualification(value: number | null | undefined): Qualification {
  if (value == null) return 'no_data';
  if (value > 95) return 'excellent';
  if (value >= 90) return 'good';
  if (value >= 80) return 'regular';
  if (value >= 70) return 'bad';
  return 'very_bad';
}
